import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {useBoardStore} from '@components/board/board-store'
import {
  TwTaskGroupTitle,
  TwTextArea,
  TwTitleRow
} from '@components/columns/column-title/containers'
import {noPropagate} from '@containers/hooks'

export const AddColumnHeader = observer(() => {
  const [, store] = useBoardStore()

  return (
    <TwTaskGroupTitle className="p-8">
      <TwTitleRow className="min-h-24" onWheelCapture={noPropagate}>
        <TwTextArea
          placeholder={Lang.msg.columnPlaceholder}
          onSubmit={store.submitNewColumn}
          onBlur={store.blurNewColumn}
          onCancel={store.cancelNewColumn}
          autoFocus
          borders={false}
          paddings="none"
          noBackground
          style={{fontWeight: '600', lineHeight: '24px', fontSize: '16px'}}
          color="primary"
          // wheel capture is required to prevent perfect scroll from handling it first
          textAreaClassName="max-h-200 !overflow-y-auto"
        />
      </TwTitleRow>
    </TwTaskGroupTitle>
  )
})
